// Environment variable validation utility
export const validateEnvironment = () => {
  // Only validate frontend-required environment variables
  const requiredVars = [
    // Removed MONGODB_URI as it's only needed in API routes, not frontend
    // Removed NEXT_PUBLIC_API_BASE_URL as we're using relative URLs now
  ];

  const missingVars = requiredVars.filter(varName => !process.env[varName]);

  if (missingVars.length > 0) {
    console.error('Missing required environment variables:', missingVars);
    throw new Error(`Missing environment variables: ${missingVars.join(', ')}`);
  }

  console.log('Environment validation passed');
  return true;
};

// Log environment status (without sensitive data)
export const logEnvironmentStatus = () => {
  console.log('Environment Status:');
  console.log('- NODE_ENV:', process.env.NODE_ENV);
  console.log('- Frontend environment validation: OK (no required vars for frontend)');
  console.log('- API routes handle their own environment validation');
};